import script from "./HeaderMain.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMain.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMain.vue?vue&type=style&index=0&id=ceb1d9ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceb1d9ce"]])

export default __exports__